/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hedera_Chain_Blocktime_ExplanationInputs */



/**
* | output |
* | --- |
* | "In the context of Hedera, a block is a simple batch of transactions, which was introduced to enhance compatibility with EVM tools. Hedera's hashgraph consens..." |
*
* @param {Hedera_Chain_Blocktime_ExplanationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const hedera_chain_blocktime_explanation = /** @type {((inputs?: Hedera_Chain_Blocktime_ExplanationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hedera_Chain_Blocktime_ExplanationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("In the context of Hedera, a block is a simple batch of transactions, which was introduced to enhance compatibility with EVM tools. Hedera's hashgraph consensus algorithm inherently doesn't utilize blocks.")
});